document.addEventListener('DOMContentLoaded', function () {
  if (window.innerWidth < 768) {
    let elem = document.querySelector('.main-carousel');
    let flkty = new Flickity(elem, {
      // options
      cellAlign: 'center',
      contain: true,
      groupCells: 1,
      wrapAround: true,
      adaptiveHeight: true,
      prevNextButtons: false
    });

    let previousButton = document.querySelector('.is-previous');
    let nextButton = document.querySelector('.is-next');

    previousButton.addEventListener('click', function() {
      flkty.previous();
    });
    nextButton.addEventListener('click', function() {
      flkty.next();
    });
  }
});
